import { isSameDay, isValid, parse, parseISO, startOfDay } from 'date-fns';

/** SubscriptionsParser reformats to dd/MM/yyyy; the dashboard passes the API's yyyy-MM-dd through. */
export const parseSubscriptionDate = (value: string): Date => {
  const display = parse(value, 'dd/MM/yyyy', new Date());
  return isValid(display) ? display : parseISO(value);
};

export const isTodayExpiryDate = (date: string | null | undefined, today: Date = new Date()): boolean => {
  if (!date) return false;
  const parsed = parseSubscriptionDate(date);
  return isValid(parsed) && isSameDay(parsed, today);
};

/** Strictly before today's date, so a renewal due today is not yet past. */
export const isBeforeExpiryDate = (date: string | null | undefined, today: Date = new Date()): boolean => {
  if (!date) return false;
  const parsed = parseSubscriptionDate(date);
  return isValid(parsed) && parsed < startOfDay(today);
};
